const getUrl = () => {
  document.querySelector('#getUrlPage').innerText = window.location.href;
}
export { getUrl };  